import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { Separator } from 'designSystem/components/Separator'
import { useEvalSessionHeaderFilters } from 'features/knowledgeDocumentViewer/contexts/EvalSessionChromeContext'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { useDocumentFullscreen } from 'features/knowledgeDocumentViewer/hooks/useDocumentFullscreen'
import { ArrowLeft, Maximize2 } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

import { DocumentHeaderTitle } from './DocumentHeaderTitle'

const StyledHeader = styled.header<{ $matchDocumentChromeSpacing: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 0.75rem;
  padding-block: ${({ $matchDocumentChromeSpacing }) =>
    $matchDocumentChromeSpacing ? '0.375rem' : '0'};
  gap: 0.75rem;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border);
`

const TrailingButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding-block: 0.375rem;
  padding-right: 0.75rem;
  margin-left: auto;
`

const HeaderFilters = styled.div`
  flex-shrink: 0;
`

export function EvalSessionHeaderBar({
  showDocumentChrome = true,
}: {
  showDocumentChrome?: boolean
} = {}): React.ReactElement {
  const { t } = useLingui()
  const { currentDocumentId, onExitEvalSession } =
    useKnowledgeDocumentUXContext()
  const headerFilters = useEvalSessionHeaderFilters()
  const { enterDocumentFullscreen } = useDocumentFullscreen()

  function handleBack(): void {
    onExitEvalSession?.()
  }

  return (
    <StyledHeader $matchDocumentChromeSpacing={!showDocumentChrome}>
      <Button
        variant='inputRaised'
        size='icon-lg'
        title={t`Back to landing`}
        onClick={handleBack}>
        <ArrowLeft size={18} />
      </Button>
      {showDocumentChrome ? (
        <DocumentHeaderTitle
          documentId={currentDocumentId}
          showDetails={false}
        />
      ) : null}
      {headerFilters ? <HeaderFilters>{headerFilters}</HeaderFilters> : null}
      {showDocumentChrome ? (
        <>
          <Separator orientation='vertical' />
          <TrailingButtonsContainer>
            <Button
              variant='inputRaised'
              size='icon-lg'
              onClick={enterDocumentFullscreen}
              title={t`Fullscreen document`}
              aria-label={t`Fullscreen document`}>
              <Maximize2 size={18} />
            </Button>
          </TrailingButtonsContainer>
        </>
      ) : null}
    </StyledHeader>
  )
}
